import React from 'react'
import styled from 'styled-components'
import { string, number, oneOf } from 'prop-types'

const StyledAvatarWrapper = styled.div`
  ${({ shape }) => {
    if (shape === 'square') {
      return 'border-radius: 8px;'
    }
    return 'border-radius: 50%;'
  }}

  border: 0px solid transparent;
  height: ${({ height }) => height}px;
  overflow: hidden;
  position: relative;
  width: ${({ width }) => width}px;
  min-width: ${({ width }) => width}px;
  margin: auto;
`

const StyledAvatar = styled.img`
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
`

export const Avatar = ({ src, alt, height, width, shape, ...rest }) => {
  return (
    <StyledAvatarWrapper height={height} width={width} shape={shape} {...rest}>
      <StyledAvatar src={src} alt={alt} height={height} width={width} />
    </StyledAvatarWrapper>
  )
}

Avatar.propTypes = {
  src: string,
  alt: string,
  height: number,
  width: number,
  shape: oneOf(['circle', 'square']),
}

Avatar.defaultProps = {
  height: 50,
  width: 50,
  shape: 'circle',
}
